<template>
  <div class="list-box">
    <div class="search">
      <el-form inline size="mini" style="position: relative; top: 7px">
        <el-form-item style="width: 140px">
          <el-input
            prefix-icon="el-icon-search"
            placeholder="请输入搜索内容"
            v-model="searchText"
            @keydown.enter.native="searchEvt"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="wbench-button" type="primary" @click="searchEvt">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="main">
      <el-checkbox-group @change="onChange" v-model="checkList" v-if="userList.length > 0">
        <div v-for="item in showList" :key="item.userId" class="user-item-full">
          <el-checkbox
            :label="item"
            :title="item.realName + '---' + item.corpName + item.departName"
          >
            <span class="user">{{ item.realName }}</span>
            <span class="corp">{{ item.corpName }}</span>
            <div class="clear"></div>
            <span v-if="item.userDuty" class="user">{{ item.userDuty }}</span>
            <span class="corp">{{ item.departName }}</span>
            <div class="clear"></div>
          </el-checkbox>
        </div>
      </el-checkbox-group>
      <div v-else class="user-no-data">暂无数据</div>
    </div>
  </div>
</template>
<script>
import { getRecentUserList, trim } from "../api";
import { getCookie } from "@szgc/plt-core-v2";
import request from "../../../api/request";

export default {
  name: "RecentUserList",
  props: {
    multiEnable: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      userList: [],
      showList: [],
      checkList: [],
      prefix: "",
      searchText: ""
    };
  },
  watch: {
    checked: {
      handler() {
        this.setChecked();
      },
      deep: true
    }
  },
  mounted() {
    this.getRecentUserList();
  },
  methods: {
    /*搜索*/
    searchEvt() {
      const searchText = trim(this.searchText);
      this.showList = this.userList.filter((item) => {
        if (searchText === "") {
          return item;
        } else {
          if (item.realName && item.realName.indexOf(searchText) > -1) {
            return item;
          } else if (item.corpName && item.corpName.indexOf(searchText) > -1) {
            return item;
          } else if (item.departName && item.departName.indexOf(searchText) > -1) {
            return item;
          } else if (item.mobile && item.mobile.indexOf(searchText) > -1) {
            return item;
          }
        }
      });
    },

    getUserData() {
      return [...this.checkList];
    },

    onChange(list) {
      if (!this.multiEnable) {
        this.checkList = [list[list.length - 1]];
      }
      this.$emit("checkUser", { data: this.userList });
    },

    async getRecentUserList() {
      this.prefix = getCookie("plt-api-route") || "";
      try {
        const { success, message, data } = await request({
          url: this.prefix + getRecentUserList(),
          method: "get"
        });
        if (!success) {
          return this.$message.error("获取最近选择用户失败：" + message);
        }
        this.userList = data;
        this.showList = data;
        this.setChecked();
      } catch (e) {
        this.$message.error("获取最近选择用户失败");
      }
    },
    /*设置选中*/
    setChecked() {
      let notRows = [];
      this.userList.map((item) => {
        let flag = false;
        this.checked.map((child) => {
          if (child.userId === item.userId) {
            flag = true;
          }
        });
        if (flag) {
          notRows.push(item);
        }
      });
      this.checkList = notRows;
    },
    /*返回所有人员*/
    getAllUser() {
      return this.showList;
    }
  }
};
</script>
<style lang="scss" scoped>
.list-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  > .search {
    padding: 0 10px;
    height: 45px;
    background-color: #f6f9f9;
    border-bottom: 1px solid #d8d8d8;
    box-sizing: border-box;

    > .el-input {
      margin-top: 9px;
    }
  }

  > .main {
    width: 100%;
    height: calc(100% - 55px);
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .user-no-data {
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #909399;
  }
}
</style>

